import React from 'react'
import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'
import {LanguageType} from '@daedalus/core/src/localization/types/LanguageType'
import {getCountryCodeFromLanguage} from '@daedalus/core/src/localization/services/country'
import Heading from '../../../../designSystem/Heading'
import Flag from '../../../../designSystem/Flag'
import {CustomInputSelect, WrapperSelector} from '../commonStyles'

const Label = styled('div')(
  () => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `
)

const StyledFlag = styled(Flag)(
  ({theme}) => css`
    margin-right: ${theme.layout.spacing.s300}px;
  `
)

type Props = {
  /** List of languages to be displayed */
  availableLanguages: LanguageType[]
  /** The currently selected value */
  currentLanguage: string
  /** The callback for when a currency is selected. The new currency code will be passed. */
  onChangeLanguage: (code: string) => void
}

const MobileLanguageSelector = ({
  availableLanguages,
  currentLanguage,
  onChangeLanguage
}: Props) => {
  const handleChange = (event: React.ChangeEvent) => {
    onChangeLanguage(event.target.value)
  }

  // TODO (Search) [2022-03-16] dq82hd-desktop-map
  const flagIcon: string = getCountryCodeFromLanguage(currentLanguage)

  return (
    <WrapperSelector>
      <Heading appearance="title3" marginBottomSize="s000">
        <FormattedMessageWrapper id="languageLabel" defaultMessage="Language" />
      </Heading>

      <Label>
        <StyledFlag size={22} countryCode={flagIcon} />
        <Heading appearance="title3" marginBottomSize="s000">
          {currentLanguage?.toUpperCase()}
        </Heading>
      </Label>

      <CustomInputSelect
        name="selectLanguage"
        id="selectLanguage"
        data-id="SelectLanguage"
        value={currentLanguage}
        onChange={handleChange}
      >
        {availableLanguages.map((language: LanguageType) => (
          <option key={language.code} value={language.code}>
            {language.displayName} ({language.code})
          </option>
        ))}
      </CustomInputSelect>
    </WrapperSelector>
  )
}

export default MobileLanguageSelector
